import React from 'react'
import { cn } from '../../utils'

type ContainerSize = 'sm' | 'md' | 'lg' | 'xl' | 'full'

interface ContainerProps {
  children: React.ReactNode
  size?: ContainerSize
  className?: string
  as?: React.ElementType
  padding?: boolean
}

const sizeStyles: Record<ContainerSize, string> = {
  sm: 'max-w-2xl',     // 672px
  md: 'max-w-4xl',     // 896px
  lg: 'max-w-6xl',     // 1152px
  xl: 'max-w-7xl',     // 1280px
  full: 'max-w-full',
}

const Container: React.FC<ContainerProps> = ({
  children,
  size = 'xl',
  className,
  as: Component = 'div',
  padding = true,
}) => {
  return (
    <Component
      className={cn(
        'mx-auto w-full',
        sizeStyles[size],
        padding && 'px-4 sm:px-6 lg:px-8',
        className
      )}
    >
      {children}
    </Component>
  )
}

export default Container
